import { ReactComponent as ShowAllEntriesSvg } from "../../assets/images/svgs/showAllEntries.svg";

const ShowAllEntriesIcon = ({ className = "", ...props }) => {
  return (
    <ShowAllEntriesSvg
      className={className}
      focusable="false"
      aria-hidden="true"
      {...props}
    />
  );
};

export default ShowAllEntriesIcon;
